// Currently we only support priorities of 0 (default) or 1. This is for handling duplicate key bindings
// within nested parts of the UI, where more deeply nested components might need to have higher priority
// when calling handlers. The key event object's preventDefault method and defaultPrevented property can
// be used to ensure that lower priority handlers are not executed.
import { KeyboardEvent, useEffect } from 'react';

interface HotkeyHandlerConfig {
  handler: (e: KeyboardEvent) => void;
  priority?: number;
}

export const useHotkeyHandler = (
  { handler, priority = 0 }: HotkeyHandlerConfig,
  deps: Array<any> = [],
) => {
  useEffect(() => {
    let eventType = 'hotkey';

    if (priority > 0) {
      eventType = `${eventType}_${priority}`;
    }

    // FIXME harden the event system
    // @ts-ignore
    window.app.on(eventType, handler);
    // @ts-ignore
    return () => window.app.off(eventType, handler);
  }, deps);
};
